/// <amd-module name="Repos/Discussion/Editor/Utils/CommentAction" />
import { IChangeWithDiscussionThread } from "Repos/Changes/Contracts";
import {
    IChangesTreeDiscussionIntegration,
    IDiffSummaryDiscussionIntegration,
    LineInfoType,
    SpecialCommentPositions
} from "Repos/Discussion/Common/DiscussionContracts";
import * as Resources from "Repos/Discussion/Editor/Resources";
import { IHeaderCommandBarItem } from "VSSUI/HeaderCommandBar";
import { ITreeItem } from "VSSUI/Utilities/TreeItemProvider";

export function addCommentToRootItem(
    rootDiffIntegration: IDiffSummaryDiscussionIntegration,
    tooltipText: string,
    showText: boolean,
    onActivate?: () => void
): IHeaderCommandBarItem {
    return {
        ariaLabel: Resources.AddCommentText,
        groupKey: "view-items",
        iconProps: { iconName: "CommentAdd" },
        id: "add-comment",
        onActivate: () => {
            onActivate && onActivate();

            rootDiffIntegration.addComment(
                {
                    lineStart: SpecialCommentPositions.File,
                    lineEnd: SpecialCommentPositions.File,
                    lineEndOffset: 0,
                    lineStartOffset: 0,
                    type: LineInfoType.Actual
                },
                false
            );
        },
        text: showText ? Resources.AddCommentText : undefined,
        tooltipProps: !showText ? { text: tooltipText } : undefined
    };
}

export function addCommentToFileItem(
    treeDiffIntegration: IChangesTreeDiscussionIntegration<ITreeItem<IChangeWithDiscussionThread>>,
    itemPath: string,
    onActivate?: () => void
): IHeaderCommandBarItem {
    return {
        groupKey: "view-items",
        iconProps: { iconName: "CommentAdd" },
        id: "add-comment",
        onActivate: () => {
            onActivate && onActivate();

            if (treeDiffIntegration) {
                treeDiffIntegration.renderAddCommentWidget(
                    itemPath,
                    {
                        lineStart: SpecialCommentPositions.File,
                        lineEnd: SpecialCommentPositions.File,
                        lineEndOffset: 0,
                        lineStartOffset: 0,
                        type: LineInfoType.Actual
                    },
                    false
                );
            }
        },
        text: Resources.AddCommentText
    };
}
